import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { DEPRECATED_CustomSelect } from "../../components/DEPRECATED_CustomSelect/DEPRECATED_CustomSelect";
import { useTranslations } from "../../providers/useTranslations";
export const GenderDropdown = ({ fieldName, isDisabled = false }) => {
    const { __ } = useTranslations();
    const { register } = useFormContext();
    const dropdownValues = [
        { value: "male", label: __("contact_info.gender.male") },
        { value: "female", label: __("contact_info.gender.female") },
        { value: "prefer_not_to_say", label: __("contact_info.gender.prefer_not_to_say") },
    ];
    useEffect(() => {
        register(fieldName);
    }, [fieldName, register]);
    return (_jsx(DEPRECATED_CustomSelect, { dataTestId: "genderDropdown", inputId: "genderDropdown", name: fieldName, isSearchable: false, placeholder: __("contact_info.gender_placeholder"), options: dropdownValues, isDisabled: isDisabled }));
};
//# sourceMappingURL=GenderDropdown.js.map